import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[lxBlockSpaces]',
  standalone: true,
})
export class BlockSpacesDirective {
  private readonly ngControl = inject(NgControl);

  // Remove spaces when the user types
  @HostListener('keydown.space', ['$event'])
  onSpace(event: KeyboardEvent) {
    event.preventDefault();
  }

  // Remove spaces when the user paste text with spaces
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const noSpaces = input.value.replace(/\s/g, '');
    if (input.value !== noSpaces) {
      this.ngControl.control?.setValue(noSpaces);
    }
  }
}
